import { InterviewTranscript, PresentationDraft, PresentationDraftStatus } from "../models/PresentationDraft";

export const MIN_TRANSCRIPT_LENGTH = 1500;
export const MAX_TRANSCRIPT_LENGTH = 200000;
export const MAX_INSTRUCTION_LENGTH = 2000;
export const MAX_CONTENT_LENGTH = 30000;
export const GENERATION_POLL_INTERVAL_MS = 4000;

const UNFINISHED_PLACEHOLDER = /\[(?:à compléter|to be completed)[^\]<]*\]?/gi;

const OPEN_STATUSES = [
	PresentationDraftStatus.Generating,
	PresentationDraftStatus.Generated,
	PresentationDraftStatus.Failed
];

export const findUnfinishedPlaceholders = (html: string): string[] => html.match(UNFINISHED_PLACEHOLDER) ?? [];

export const isOpenDraft = (draft: PresentationDraft): boolean => OPEN_STATUSES.includes(draft.status);

/** Drafts arrive newest first: the first open one is the draft the TAM is working on. */
export const getOpenDraft = (drafts: PresentationDraft[] | undefined): PresentationDraft | undefined =>
	drafts?.find(isOpenDraft);

export const getLatestPublishedDraft = (drafts: PresentationDraft[] | undefined): PresentationDraft | undefined =>
	drafts?.find(draft => draft.status === PresentationDraftStatus.Published);

export const isGenerating = (drafts: PresentationDraft[] | undefined): boolean =>
	!!drafts?.some(draft => draft.status === PresentationDraftStatus.Generating);

export const isTranscriptLongEnough = (transcript: string): boolean =>
	transcript.trim().length >= MIN_TRANSCRIPT_LENGTH;

export const presentationReviewPath = (freelancerProfileKey: string): string =>
	`/applications/talent/${freelancerProfileKey}/presentation`;

export const talentDetailsPath = (freelancerProfileKey: string): string =>
	`/applications/talent/${freelancerProfileKey}`;

/** An imported interview is sent by id only while its text is untouched; any edit makes it a manual entry. */
export const toInterviewPayload = (
	text: string,
	imported?: InterviewTranscript
): { transcriptId?: number; text?: string } =>
	imported && imported.text === text ? { transcriptId: imported.transcriptId } : { text: text.trim() ? text : undefined };
